export default __webpack_public_path__ + "media/images/manual/joanr/18-943259a5b3f1bd38a860f7595bed11f0.png";